import routes from './routes';
import { SetRoutes } from 'components';

const VacancyApplicationTypesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default VacancyApplicationTypesPages;
